import SimilarItemsContainer from './SimilarItems.container';
export default SimilarItemsContainer;
